import { stableFingerprint } from "./decimal.js";

export interface StatementUploadOperationInputV2 {
  schemaVersion: "tradvera.portfolio-v2.statement-upload.v1";
  bookId: string;
  idempotencyKey: string;
  fileSha256: string;
  bytes: number;
}

export function canonicalStatementUploadOperationInputV2(input: StatementUploadOperationInputV2): StatementUploadOperationInputV2 {
  const bookId = identifier(input.bookId);
  const idempotencyKey = identifier(input.idempotencyKey);
  const fileSha256 = input.fileSha256.trim().toLowerCase();
  if (input.schemaVersion !== "tradvera.portfolio-v2.statement-upload.v1"
    || !/^[a-f0-9]{64}$/u.test(fileSha256)
    || !Number.isSafeInteger(input.bytes) || input.bytes < 1 || input.bytes > 25 * 1024 * 1024) invalid();
  return { schemaVersion: input.schemaVersion, bookId, idempotencyKey, fileSha256, bytes: input.bytes };
}

export function statementUploadInputFingerprintV2(input: StatementUploadOperationInputV2): string {
  return stableFingerprint(canonicalStatementUploadOperationInputV2(input));
}

function identifier(value: string): string {
  const result = value.trim();
  if (result.length < 3 || result.length > 160 || !/^[A-Za-z0-9._:/-]+$/u.test(result)) invalid();
  return result;
}
function invalid(): never { throw new Error("STATEMENT_UPLOAD_INPUT_INVALID"); }
